import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Stats from './Components/Stats';
import Resume from './Components/Resume';
import Contact from './Components/Contact';
import Testimonials from './Components/Testimonials';
import Portfolio from './Components/Portfolio';
import ProfessionalPage from './Components/ProfessionalPage';
import JavaInterviewPage from './Components/JavaInterviewPage';
import BackendDemo from './Components/BackendDemo';
import SpringBootDeepDive from './Components/SpringBootDeepDive';
import JavaDeepDive from './Components/JavaDeepDive';
import GlobalCoach from './Components/GlobalCoach';
import AssistantPage from './Components/AssistantPage';
import AdditionalDetails from './Components/AdditionalDetails';
import FacelessVideoFactory from './Components/FacelessVideoFactory/FacelessVideoFactory';
import NordstromTimeline from './Components/NordstromTimeline';
import { InterviewProvider } from './Components/useInterviewContext';

import resumeData from './resumeData.json';

const App = () => {
  const [route, setRoute] = useState('home');

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (['pdm', 'tpm', 'em', 'swe', 'java-interview', 'java-demo', 'springboot', 'java-deep-dive', 'assistant', 'faceless-video-factory', 'nordstrom-timeline'].includes(hash)) {
        setRoute(hash);
      } else {
        setRoute('home');
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange(); // Initial check

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    // If we are on home route and have a hash, scroll to it
    if (route === 'home' && window.location.hash) {
      const id = window.location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        // If element doesn't exist yet (e.g. initial load), try after a short delay
        setTimeout(() => {
          const retryElement = document.getElementById(id);
          if (retryElement) retryElement.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [route]);

  const renderContent = () => {
    switch (route) {
      case 'pdm':
        return <ProfessionalPage type="pdm" data={resumeData} />;
      case 'tpm':
        return <ProfessionalPage type="tpm" data={resumeData} />;
      case 'em':
        return <ProfessionalPage type="em" data={resumeData} />;
      case 'swe':
        return <ProfessionalPage type="swe" data={resumeData} />;
      case 'java-interview':
        return <JavaInterviewPage />;
      case 'java-demo':
        return <BackendDemo />;
      case 'springboot':
        return <SpringBootDeepDive />;
      case 'java-deep-dive':
        return <JavaDeepDive />;
      case 'assistant':
        return <AssistantPage />;
      case 'faceless-video-factory':
        return <FacelessVideoFactory />;
      case 'nordstrom-timeline':
        return <NordstromTimeline />;
      default:
        return (
          <>
            <Header data={resumeData.main} />
            <About data={resumeData.main} />
            <Resume data={resumeData.resume} />
            <Portfolio data={resumeData.portfolio} />
            <AdditionalDetails />
            <Testimonials data={resumeData.testimonials} />
            <Contact data={resumeData.main} />
            <Footer data={resumeData.main} />
          </>
        );
    }
  };

  return (
    <InterviewProvider>
      <div className="App">
        {renderContent()}
        <GlobalCoach />
      </div>
    </InterviewProvider>
  );
};

export default App;
